import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-icons-counter',
    templateUrl: './icons-counter.shared.component.html',
    styleUrls: ['./icons-counter.shared.component.scss']
})
export class IconsCounterComponent implements OnInit {
    private _height: number = 35;

    @Input() public current: number;
    @Input() public of: number;
    @Input() public iconInactive: string = 'icon.program-hot-empty.svg';
    @Input() public iconActive: string = 'icon.program-hot-full.svg';
    @Input() public pathToImages: string = '/assets/icons/';

    constructor() { }

    ngOnInit(): void { }

    public get inactiveCountArr(): Array<undefined> {
        return new Array(this.of || 0);
    }

    public get activeCountArr(): Array<undefined> {
        return new Array(this.of && this.current || 0);
    }

    public get imagesPath(): string {
        return this.pathToImages;
    }

    public handleImageLoaded($event: Event): void {
        this._height = ($event as any)?.path[0]?.height || 35;
    }

    public get height(): string {
        return this._height + 'px';
    }
}
